module.exports = "/_next/static/images/BusinessPlan-xs-ee2a81590ed85e0b8570c29a77a47bb1.webp";